<template>
    <div class="class-detail">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase ls-1 mb-1">SELAMAT MENGERJAKAN . . .</h6>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="py-1 text-right">
                                <b-button id="collect-test" v-if="!showLoader" variant="custom-primary" size="sm" @click.prevent="collectTest()">KUMPULKAN</b-button>
                            </div>
                            <div class="table-responsive" v-if='questionList.length'>
                                <table class="table VueTables__table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Butir Soal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in questionList" :key="index">
                                            <td>{{(index+1)}}</td>
                                            <td>
                                                <div class="my-2">
                                                    <img v-if="item.file_path"
                                                        class="img-center-200"
                                                        width="100"
                                                        :src="item.file_path"
                                                        alt="Logo"
                                                    />
                                                    <b-form data-vv-scope="question-test-form">
                                                        <b-form-group :label="item.question">
                                                            <div v-for="(option, index1) in item.options" :key="index1">
                                                                <b-form-radio 
                                                                    :name="'soal-'+index"
                                                                    data-vv-as="Soal"
                                                                    v-model="item.answer"
                                                                    class="mb-1"
                                                                    :value="option.id"
                                                                    v-validate="''"
                                                                    >
                                                                    {{option.choice}}
                                                                </b-form-radio>
                                                                <img v-if="option.file_path"
                                                                    class="sticky-img-200"
                                                                    width="100"
                                                                    :src="option.file_path"
                                                                    alt="Logo"
                                                                />
                                                            </div>
                                                            <!-- <b-form-radio-group
                                                                :id="item.id"
                                                                :name="'soal-'+index"
                                                                data-vv-as="Soal"
                                                                v-model="item.answer"
                                                                :options="item.options"
                                                                class="mb-3"
                                                                value-field="id"
                                                                text-field="choice"
                                                                disabled-field="notEnabled"
                                                                v-validate="''"
                                                            ></b-form-radio-group> -->
                                                            <span :class="{'error-validation': errors.first('question-test-form.'+'soal-'+index)}">{{errors.first('question-test-form.'+'soal-'+index)}}</span>
                                                        </b-form-group>
                                                    </b-form>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="py-1 text-right" >
                                <b-button id="collect-test" v-if="!showLoader" variant="custom-primary" size="sm" @click.prevent="collectTest()">KUMPULKAN</b-button>
                            </div>
                            <!-- <v-client-table ref="question_ref" :data="questionList" :columns="columns" :options="options">
                                <div slot="nomor" slot-scope="{ index }">
                                    <div class="my-2">
                                        <p>{{index}}</p>
                                    </div>
                                </div>
                                <div slot="question" slot-scope="props">
                                    <div class="my-2">
                                        <b-form-group :label="props.row.question">
                                            <b-form-radio-group
                                                :id="props.row.id"
                                                :name="'soal-'+props.row.id"
                                                v-model="answer[props.row.id]"
                                                :options="props.row.options"
                                                class="mb-3"
                                                value-field="id"
                                                text-field="choice"
                                                disabled-field="notEnabled"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </v-client-table> -->
                        </div>
                    </card>
                </div>
                <div class="col-xl-4">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                            </div>
                        </div>
                        <div class="identity px-2">
                            <p class="line-with-icon"><i class="fa fa-user" aria-hidden="true"></i>{{question.username}}</p>
                            <p class="line-with-icon"><i class="fa fa-envelope" aria-hidden="true"></i>{{question.email}}</p>
                            <p class="line-with-icon"><i class="fa fa-suitcase" aria-hidden="true"></i>{{question.name}}</p>
                        </div>
                        <hr>
                        <div class="card class-followed text-center">
                            <div class="card-header font-weight-bold">
                                SISA WAKTU
                            </div>
                            <div class="card-body">
                                <div class="outer-container">
                                    <div class="inner-container">
                                        <div class="countdown text-center">
                                            <h2>{{ timeLeft }}</h2>
                                        </div>
                                        <!-- <ul class="columns is-mobile is-centered text-center">
                                            <span v-for="(time, index) in times" :key="index" class="column time">
                                                <a v-on:click.prevent="setTime(time.sec)" :class="[
                                                        'button',
                                                        'is-link',
                                                        {'is-active': time.sec === selectedTime && endTime !== 0 }
                                                    ]">
                                                    {{ time.display }}
                                                </a>
                                            </span>
                                        </ul> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="card class-followed text-center">
                            <div class="card-header font-weight-bold">
                                JUMLAH SOAL
                            </div>
                            <div class="card-body">
                                <h6>{{question.total_soal}}</h6>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    // import { EventBus } from '@/eventBus.js'
    // import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        components: {
            // SquareLoader
        },
        data() {
            return {
                showLoader: false,
                formQuiz: {
                    quiz_id: this.$route.params.appraisalId,
                    duration: null,
                    answers: [
                    ]
                },
                columns: ['nomor', 'question'],
                selectedTime: 0,
                timeLeft: '00:00:00',
                endTime: '0',
                secondsLeft: 0,
                times: [
                    {
                        sec: 3,
                        display: '3s'
                    },
                    {
                        sec: 600,
                        display: ' 10m'
                    },
                    {
                        sec: 5000,
                        display: '30m'
                    }
                ],
                options: {
                    headings: {
                        nomor: 'No.',
                        question: 'Butir Soal',
                    },
                    initialPage: 1,
                    perPage: 1,
                    filterable: false,
                    pagination: {
                        chunk:1,
                        nav: 'relative',
                        edge: false,
                        show: true
                    },
                    rowAttributesCallback() {
                        return {
                            "style": "text-align: left;"
                        }
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                question: 'getDetailQuestionOverview',
                questionList: 'getDetailQuestionlist',
                currentModulId: 'getCurrentModulId'
            })
        },
        watch: {
            secondsLeft(newVal) {
                if (newVal == 0) {
                    this.$swal.fire({
                        title: 'Perhatian!',
                        text: 'Waktu pengerjaan soal telah habis!',
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'OK',
                    }).then(() => {
                        let scope = 'question-test-form'
                        this.submitQuestion(scope)
                    })
                }
            },
            question(newVal) {
                if (newVal.duration > 0) {
                    this.setTime(newVal.duration)
                } else {
                    this.$swal.fire({
                        title: 'Perhatian!',
                        text: 'Waktu pengerjaan soal telah habis!',
                        icon: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'OK',
                    }).then(() => {
                        let scope = 'question-test-form'
                        this.submitQuestion(scope)
                    })
                }
            }
        },
        methods: {
			async getQuestion() {
                let quizId = this.$route.params.appraisalId
				await this.$store.dispatch('getQuestion', { quizId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            setTime(seconds) {
                this.secondsLeft = seconds
                this.timer()
            },
            timer() {
                const now = Date.now();
                const end = now + this.secondsLeft * 1000;
                this.displayTimeLeft(this.secondsLeft);

                this.selectedTime = this.secondsLeft;
                this.countdown(end);
            },
            countdown(end) {
                setInterval(() => {
                    this.secondsLeft = Math.round((end - Date.now()) / 1000);

                    if(this.secondsLeft === 0) {
                        this.endTime = 0;
                    }

                    if(this.secondsLeft < 0) {
                        return;
                    }
                    this.displayTimeLeft()
                }, 1000);
            },
            displayTimeLeft() {
                const hours = Math.floor((this.secondsLeft / 3600));
                const minutes = Math.floor((this.secondsLeft % 3600) / 60);
                const seconds = this.secondsLeft % 60;

                this.timeLeft = `${zeroPadded(hours)}:${zeroPadded(minutes)}:${zeroPadded(seconds)}`;
            },
            async collectTest() {
                let scope = 'question-test-form'
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.$validator.validateAll(scope).then(valid => {
                            if (valid) {
                                this.submitQuestion(scope)
                            }
                        });
                    }
                })
            },
            async submitQuestion(scope) {
                let collectAnswer = []
                this.questionList.forEach(element => {
                    if (element.answer) {
                        let answer = {
                            question_id: element.id,
                            option_id: element.answer
                        }
                        collectAnswer.push(answer)
                    }
                });
                this.formQuiz.duration = this.question.duration
                this.formQuiz.answers = collectAnswer
                this.showLoader = true
                let form = this.formQuiz
                this.$store.dispatch('submitQuestion', form)
                    .then((res) => {
                        this.showLoader = false
                        this.$validator.reset()
                        this.$router.push({ name: 'modul-appraisal', params: { modulId: localStorage.getItem('currentModulId') }  })
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            }
        },
        async created() {
            await this.getQuestion()
            this.$validator.reset()
        }
    }
    function zeroPadded(num) {
    // 4 --> 04
    return num < 10 ? `0${num}` : num;
    }
</script>
<style scoped>
.btn-custom-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.btn-custom-primary:hover, .btn-custom-primary:not(:disabled):not(.disabled):active, .btn-custom-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
::v-deep .custom-control-inline {
    display: block !important;
}
@media (max-width: 480px) {
    #collect-test {
        width: 100% !important;
    }
}
@media (max-width: 768px) {
    #collect-test {
        width: 50%;
    }
}
@media (min-width: 769px) {
    #collect-test {
        width: 25%;
    }
}
</style>
<style scoped>
::v-deep .VueTables__search-field label {
    display: none !important;
}
::v-deep .VuePagination__count {
    display: none;
}
::v-deep .VueTables__row {
    background-color: white !important;
    --bs-table-accent-bg: unset !important;
}
::v-deep .VueTables__table thead tr th:first-child {
    width: 5px;
}
::v-deep .VueTables__table thead tr th {
    background-color: #ca062a;
    color: white;
    border-color: #ca062a;
}
::v-deep .VuePagination nav {
    display: flex!important;
    -webkit-box-pack: end!important;
    -ms-flex-pack: end!important;
    justify-content: flex-end!important;
}
::v-deep .VuePagination, ::v-deep .VuePagination nav {
    padding: 0 !important;
    margin: 0 !important;
}
</style>